import React from 'react'
import { useState, useEffect } from 'react';
import { make_readable_date } from '../../js functions/chartCompute.js';
import { get_data_of_exercise } from '../../js functions/LDBfunctions';
import Counter from './master/counter.js';
import Line_chart from './master/Line_chart.js';

function OneRepMax({ dateRangeStart, dateRangeEnd, ActiveExcercise }) {

    const [oneRepMaxData, setOneRepMaxData] = useState([]);
    const heading = "New One Rep Max";
    const Yaxis_name = "Weight (kg)";
    const [slope, setSlope] = useState(0);

    useEffect(() => {

        compute_oneRM(dateRangeStart, dateRangeEnd, ActiveExcercise);

    }, [dateRangeStart, dateRangeEnd, ActiveExcercise]);




    async function compute_oneRM(dateRangeStart, dateRangeEnd, ActiveExcercise) {

        try {
            const data = await get_data_of_exercise(dateRangeStart, dateRangeEnd, ActiveExcercise);
            if (!data || data.length === 0) {

                console.log('No data available for the selected exercise and date range');
                setOneRepMaxData([]);
            } else {



                const chartData = [];

                data.forEach((record) => {
                    let rolling_1RM = 0;

                    const sets = record.sets;

                    sets.forEach((set) => {
                        sets.set_index = sets.set_index + 1;

                        const RM = set.weight_kg * (1 + set.reps / 30);

                        rolling_1RM = rolling_1RM + RM;
                    });

                    const sets_count = sets.length;

                    const average_1RM = rolling_1RM / sets_count;

                    rolling_1RM = 0;

                    //push to chartData;

                    chartData.push({
                        y: average_1RM,
                        x: make_readable_date(record.start_time),
                    });
                });

                setOneRepMaxData(chartData);



            }

        } catch (error) {
            console.error('Error fetching data:', error);


        }





    }









    return (
        <div className='chart-card-container'>
            <h4>{heading}</h4>

            <div className="chart-card">


                <div className='summary-box' >



                    <div className='counter-box' >

                        <Counter counterData={slope} heading={"Slope"} />

                        <Counter />

                    </div>


                    <p> Great job! Your total volume for incline dumbbell press has increased by 15% over the last month. This shows your chest and upper body strength are improving steadily. Keep it up!  </p>
                </div>



                <Line_chart data={oneRepMaxData} Yaxis_name={Yaxis_name} />



            </div>


        </div>
    )
}

export default OneRepMax